import SplitType from "split-type"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function initKaraoke() {
  const elementsToSplit = document.querySelectorAll(".split-lines")
  const instancesOfSplit = []

  // Function to replace spaces after single letters with non-breaking spaces
  function replaceSingleLetterSpaces(element) {
    const czechSingleLetters = ['a', 'i', 'o', 'u', 'k', 's', 'v', 'z']
    let text = element.innerHTML
    czechSingleLetters.forEach(letter => {
      const regex = new RegExp(`\\b${letter} `, 'g')
      text = text.replace(regex, `${letter}&nbsp;`)
    })
    element.innerHTML = text
  }

  // Split the text up
  function runSplit() {
    elementsToSplit.forEach((element, index) => {
      instancesOfSplit[index] = new SplitType(element, {
        types: "lines, words",
      });
  
      const lines = element.querySelectorAll(".line");
      lines.forEach((line, lineIndex) => {
        const words = line.querySelectorAll(".word");
        words.forEach((word, wordIndex) => {
          const text = word.textContent.trim();
          if (text.length === 1 && isCzechSingleLetter(text)) {
            if (wordIndex < words.length - 1) {
              const nextWord = words[wordIndex + 1];
              nextWord.textContent = `${text} ${nextWord.textContent}`;
              word.remove();
            } else if (lineIndex < lines.length - 1) {
              const nextLine = lines[lineIndex + 1];
              const nextLineWords = nextLine.querySelectorAll(".word");
              if (nextLineWords.length > 0) {
                const firstWordInNextLine = nextLineWords[0];
                firstWordInNextLine.textContent = `${text} ${firstWordInNextLine.textContent}`;
                word.remove();
              }
            }
          }
        });
      });
    });
  
    document.querySelectorAll(".line").forEach((line) => {
      const lineMask = document.createElement("div");
      lineMask.classList.add("line-mask");
      line.appendChild(lineMask);
    });
  
    checkTextAlignment();
  }

  // Check if the letter is a single Czech letter
  function isCzechSingleLetter(letter) {
    const czechSingleLetters = ['a', 'i', 'o', 'u', 'k', 's', 'v', 'z']
    return czechSingleLetters.includes(letter.toLowerCase())
  }

  // Check and apply text alignment
  function checkTextAlignment() {
    document.querySelectorAll(".split-lines").forEach((element) => {
      const computedStyle = window.getComputedStyle(element);
      const textAlign = computedStyle.textAlign;
      element.querySelectorAll(".line").forEach((line) => {
        line.style.textAlign = textAlign;
      });
    });
  }

  // Ensure the text is split after the page has fully loaded
  window.onload = function () {
    const scrollPosition = window.scrollY;
    runSplit();
    createAnimation();
    window.scrollTo(0, scrollPosition);
  };

  // Initialize animations on load
  function createAnimation() {
    document.querySelectorAll(".line").forEach((line) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: line,
          start: "top center",
          end: "bottom center",
          scrub: 1,
          onEnter: () => {
            gsap.to(line.querySelector(".line-mask"), { width: "0%" });
          },
          onLeaveBack: () => {
            gsap.to(line.querySelector(".line-mask"), { width: "100%" });
          },
        },
      });
    });
  }

  // Update on window resize
  let windowWidth = window.innerWidth;
  window.addEventListener("resize", function () {
    if (windowWidth !== window.innerWidth) {
      const scrollPosition = window.scrollY;
      windowWidth = window.innerWidth;
      elementsToSplit.forEach((element, index) => {
        instancesOfSplit[index].revert();
        instancesOfSplit[index] = new SplitType(element, {
          types: "lines, words",
        });
      });
      checkTextAlignment();
      runSplit();
      createAnimation();
      window.scrollTo(0, scrollPosition);
    }
  });

  // Select the container element that will change
  const container = document.querySelector("#portfolio") 

  // Create a MutationObserver instance
  const observer = new MutationObserver((mutationsList, observer) => {
    // Run your functions when mutations are detected
    runSplit()
    createAnimation()
    // Disconnect the observer after running the functions
    observer.disconnect()
  })

  // Reinitialize on button click if the button exists
  const parksBtns = document.querySelectorAll(".parks__btn")
  parksBtns.forEach((parksBtn) => {
    parksBtn.addEventListener("click", (event) => {
      event.preventDefault() // Prevent default behavior
      observer.observe(container, { childList: true, subtree: true })

      window.dispatchEvent(new Event("resize"))
    })
  })
}
